import { Typography, Box } from "@mui/material";

interface CustomerAppLabelProps {
    customer: string;
    app: string;
}

export function CustomerAppLabel({ customer, app }: CustomerAppLabelProps) {
    return (
        <Box>
            <Typography variant="body2">{customer}</Typography>
            <Typography variant="caption" color="GrayText">
                {app}
            </Typography>
        </Box>
    );
}
